import React, { useContext } from "react";
import Tags from "../Tags";
import { LanguageContext, text } from "../../container/language";
import Link from "../../utils/Link";
import moment from "moment";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const newsTypeLabels = {
  NEWS: "njoftime",
  PUBLICATION: "publikime",
  ACTIVITY: "aktivitete",
  RECRUITMENT: "rekrutime",
};

const News = ({
  highlighted,
  publishDate,
  created_at,
  cover,
  title,
  url,
  tags,
  slug,
  type,
}) => {
  const { userLanguage } = useContext(LanguageContext);
  return (
    <li
      className={`news-list__item news-list__item--${
        highlighted && "highlighted"
      }`}
    >
      <div className="row">
        <div className="col-12 col-md-2">
          <figure className="rounded">
            <Link
              to={`/lajme/${newsTypeLabels[type]}/${slug}`}
              title={text(title, userLanguage)}
            >
              <GatsbyImage
                image={getImage(
                  cover.localFile.childImageSharp.gatsbyImageData
                )}
                alt={text(title, userLanguage)}
              />
            </Link>
          </figure>
        </div>
        <div className="col-12 col-md-10">
          <div className="post-content">
            {tags && <Tags data={tags} />}
            <ul className="post-meta">
              <li className="post-date">
                <i className="uil uil-calendar-alt"></i>
                <span>
                  {" "}
                  {moment(publishDate || created_at).format("DD/MM/YYYY")}
                </span>
              </li>
            </ul>
            <h3>
              <Link
                className="link-dark"
                to={`/lajme/${newsTypeLabels[type]}/${slug}`}
                title={text(title, userLanguage)}
              >
                <font>
                  <font>{text(title, userLanguage)}</font>
                </font>
              </Link>
            </h3>
          </div>
        </div>
      </div>
    </li>
  );
};

export default News;

// {/* <li
//   className={`news-list__item news-list__item--${
//     highlighted && "highlighted"
//   }`}
// >
//   <article>
//     {tags && <Tags data={tags} />}
//     <time datetime="" className="news-list__date">
//       <font>
//         <font>
//           {moment(publishDate || created_at).format("DD/MM/YYYY")}
//         </font>
//       </font>
//     </time>
//     <h2 className="news-list__title">
//       <Link to={`/lajme/${newsTypeLabels[type]}/${slug}`} title={text(title, userLanguage)}>
//         <font>
//           <font>{text(title, userLanguage)}</font>
//         </font>
//       </Link>
//     </h2>
//   </article>
// </li> */}
